import { NgModule } from '@angular/core';
import { CityAttributeRoutingModule } from './city-attribute.routing';
import { UpdateCityAttributeComponent } from './update-city-attribute/update-city-attribute.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [UpdateCityAttributeComponent],
  imports: [SharedModule, CityAttributeRoutingModule]
})
export class CityAttributeModule {}
